// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function TwitterLogoIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M30.924 8.617A1 1 0 0 0 30 8h-3.804a6.083 6.083 0 0 0-5.184-3 5.864 5.864 0 0 0-4.218 1.712A5.987 5.987 0 0 0 15 11v.761C9.967 10.434 5.851 6.34 5.808 6.296a1 1 0 0 0-1.707.615c-.538 5.974 1.197 9.972 2.75 12.273a13.864 13.864 0 0 0 2.735 3.025C7.682 24.4 4.685 25.55 4.652 25.564a1 1 0 0 0-.48 1.491c.093.14.468.631 1.384 1.09C6.69 28.712 8.185 29 10 29c8.834 0 16.215-6.802 16.969-15.555l3.738-3.738a1 1 0 0 0 .217-1.09Zm-5.625 3.677a1 1 0 0 0-.29.642C24.5 20.823 17.91 27 10 27c-1.32 0-2.25-.175-2.902-.385 1.438-.781 3.445-2.125 4.734-4.06a1 1 0 0 0-.332-1.42c-.059-.034-5.489-3.293-5.5-12 2 1.625 5.656 4.146 9.834 4.849A1 1 0 0 0 17 13v-2a4.002 4.002 0 0 1 1.2-2.865A3.867 3.867 0 0 1 20.988 7c1.582.02 3.06.985 3.68 2.401a1 1 0 0 0 .916.599h2l-2.285 2.294Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
